module.exports = __webpack_public_path__ + "img/share-icon.f38cecc5.svg";